export var ExportDateType;
(function (ExportDateType) {
    ExportDateType["FullData"] = "FullData";
    ExportDateType["DateRange"] = "DateRange";
    ExportDateType["CustomQuarter"] = "CustomQuarter";
    ExportDateType["LastAvailableQuarter"] = "LastAvailableQuarter";
})(ExportDateType || (ExportDateType = {}));
export const exportDataModalState = {
    exportDate: ExportDateType.FullData,
    exportName: "",
    from: undefined,
    includeCustomFields: false,
    includeEsgData: false,
    includeInvestorAccounts: undefined,
    label: undefined,
    selectedQuarter: undefined,
    to: undefined
};
